<script>
import appConfig from '@/app.config'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <RouterView :key="$route.fullPath" />
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="sass" scoped>
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress

// ===
// Vendor
// ===

#nprogress
  .bar
    background: map-get($teal, 'darken-1')
</style>
